<template> 
	<div>
		<div class='knd-story'>

			<kinesis-container :event='"scroll"' :duration="1" class="story-telefoon-wrapper">
				<div class="story-telefoon-bg"></div>
				<kinesis-element 
					:strength="-500" 
					class="story-telefoon mobiel">
							<video playsinline loop muted autoplay class="story-scherm">
							<source 
								:src='require("@/assets/video/0_intro_video.mp4")'
								type="video/mp4" />
							Uw browser ondersteunt het element <code>video</code> niet.
						</video>
						<p class="video-credit">Bron: TikTok/Youtube</p>
				</kinesis-element>
			</kinesis-container>

			<div class="step" id="step_0"></div>

			<div class="story-tekst" v-if="content">
				<div class="story-intro">
					<label>INTERACTIEF VERHAAL</label>
					<h1>{{ content.intro.kop }}</h1>
					<label class="datum">25 september 2021</label>
				</div>

				<div class="story-bodytekst first">
					<p class="knd-intro">{{ content.intro.tekst }}</p>
					<p>{{ content.tekst_1.tekst }}</p>
				</div>
			</div>

			<kinesis-container :event='"scroll"' :duration="1" class="story-telefoon-wrapper">
				<div class="story-telefoon-bg"></div>
				<kinesis-element 
					:strength="-500" 
					class="story-telefoon mobiel">
						<TiktokSwiper/>
						<p class="video-credit-tiktok">Bron: TikTok</p>
				</kinesis-element>
			</kinesis-container>

			<div class="step" id="step_1"></div>

			<div class="story-tekst" v-if="content">
				<div class="story-bodytekst">
					<h3>{{ content.tekst_2.tussenkop }}</h3>
					<p>{{ content.tekst_2.tekst_1 }}</p>
					<p>{{ content.tekst_2.tekst_2 }}</p>
				</div>
			</div>

			<div class="artikel-link" @click='gotoLink("https://pointer.kro-ncrv.nl/knap-van-marketeers-dat-half-nederland-denkt-dat-een-croissant-met-jus-gezond-is")'>
				<div class="link-image">
					<img :src='require("@/assets/images/link_croissant.png")' />
				</div>
				<p>'Knap van marketeers dat half Nederland denkt dat een croissant met jus gezond is'</p>
			</div>

			<div class="story-tekst" v-if="content">
				<div class="story-bodytekst">
					<p v-html="content.tekst_3.tekst"></p>
				</div>
			</div>

			<div class="story-grafiek">
				<div class="grafiek-wrapper">
					<h3>Hoe is in de afgelopen 30 jaar overgewicht bij kinderen veranderd?</h3>
					<p>Geef je eigen schatting en kom erachter</p>

					<div class="knd-chart-draw" 
						ref="overgewicht_grafiek">
					</div>

					<div class="knd-button" 
						@click="grafiekButtonClick" 
						:style="'visibility:' + grafiekStates[currentState].button">
						<span>{{ grafiekStates[currentState].button_tekst }}</span>
						<img :src="grafiekStates[currentState].button_icon()" />
					</div>

					<div class="grafiek-explain" 
						:style="'visibility:' + grafiekStates[currentState].explain">
						<span>{{ grafiekStates[currentState].explain_tekst }}</span>
						<div class="grafiek-explain-ok"
							@click="grafiekExplainClick">OK</div>
					</div>

					<p class="grafiek-credit" @click='gotoLink("https://www.volksgezondheidenzorg.info/onderwerp/overgewicht/cijfers-context/trends#node-trend-overgewicht-kinderen-naar-leeftijd")'>Bron: Ministerie van Volksgezondheid en Zorg</p>
				</div>
			</div>

			<div class="story-tekst" v-if="content">
				<div class="story-bodytekst">
					<h3>{{ content.tekst_4.tussenkop }}</h3>
					<p v-html="content.tekst_4.tekst"></p>
					<p v-html="content.tekst_5.tekst"></p>
				</div>
			</div>

			<div class="story-grafiek">
				<div class="grafiek-wrapper">
					<iframe src='https://flo.uri.sh/visualisation/7287421/embed' title='Interactive or visual content' class='flourish-embed-iframe' frameborder='0' scrolling='no' style='width:100%;height:700px;' sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'></iframe>
				</div>
			</div>


			<div class="story-tekst" v-if="content">
				<div class="story-bodytekst">
					<h3>{{ content.tekst_5a.tussenkop }}</h3>
					<p>{{ content.tekst_5a.tekst }}</p>
				</div>
			</div>

			<div class="artikel-link" @click='gotoLink("https://pointer.kro-ncrv.nl/denk-je-dat-je-zelf-kiest-wat-je-eet-vergeet-het-maar-ook-jij-wordt-gestuurd")'>
				<img :src='require("@/assets/images/link_bromvlieg.png")' />
				<p>Denk je dat je zelf kiest wat je eet? Vergeet het maar, ook jij wordt gestuurd</p>
			</div>

			<div class="story-tekst" v-if="content">
				<div class="story-bodytekst">
					<p v-html="content.tekst_5b.tekst_1"></p>
					<p>{{ content.tekst_5b.tekst_2 }}</p>
				</div>
			</div>

			<div class="story-tekst" v-if="content">
				<div class="story-bodytekst">
					<h3>{{ content.tekst_6.tussenkop }}</h3>
					<p>{{ content.tekst_6.tekst }}</p>
				</div>
			</div>

			<div class="step" id="step_2"></div>

			<kinesis-container :event='"scroll"' :duration="1" class="story-telefoon-wrapper youtube">
				<div class="story-telefoon-bg"></div>
				<div class="youtube-quiz">
					<div class="quiz-wrapper">
						<div class="quiz-vraag">
							<p>In hoeveel van deze zeven YouTubefilmpjes heb je onbedoelde reclame gezien?</p>
						</div>
						<div class="quiz-antwoorden">
							<div v-for="(vraag, index) in quizVragen"
								:key="index +'-vraag'"
								class="quiz-button"
								:class='getBtnClr(vraag.correct)'
								@click="quizClick(index)">

								<img v-if="vraag.show_icon" :src='vraag.icon' />
								<span>{{ vraag.antwoord }}</span>
							</div>
						</div>
						<div class="quiz-uitleg" v-if="quizDone">
							<p>Alleen in het filmpje van Team Dylan Haegens over chocoladeletters is een duidelijke samenwerking met snoepfabrikant Jamin.</p>
						</div>
					</div>
				</div>
				<kinesis-element 
					:strength="180" 
					:type='"rotate"' 
					:transformOrigin='"50%"'
					class="story-telefoon visible landscape">
						<YoutubeSwiper/>
						<p class="video-credit-youtube">Bron: Youtube</p>
				</kinesis-element>
			</kinesis-container>

			<div class="story-tekst" v-if="content">
				<div class="story-bodytekst">
					<p>{{ content.tekst_7.tekst_1 }}</p>
					<p>{{ content.tekst_7.tekst_2 }}</p>
					<p>{{ content.tekst_7.tekst_3 }}</p>
				</div>
			</div>

			<kinesis-container :event='"scroll"' :duration="1" class="story-telefoon-wrapper">
				<div class="story-telefoon-bg"></div>
				<kinesis-element 
					:strength="-500" 
					class="story-telefoon mobiel citaat">
						<h3>{{ content.citaat.tekst }}</h3>
				</kinesis-element>
			</kinesis-container>

			<div class="step" id="step_3"></div>

			<div class="story-tekst" v-if="content">
				<div class="story-bodytekst">
					<p>{{ content.tekst_8.tekst_1 }}</p>
					<p>{{ content.tekst_8.tekst_2 }}</p>
					<h3>{{ content.tekst_9.tussenkop }}</h3>
					<p>{{ content.tekst_9.tekst_1 }}</p>
					<p>{{ content.tekst_9.tekst_2 }}</p>
					<p v-html="content.tekst_9.tekst_3"></p>
				</div>
			</div>

			<div class="story-tekstblok" v-if="content">
				<img :src='require("@/assets/images/strooigoed.png")' />
				<h3>{{ content.tekstblok_1.tussenkop }}</h3>
				<p>{{ content.tekstblok_1.tekst_1 }}</p>
				<p v-html="content.tekstblok_1.tekst_2"></p>
				<p>{{ content.tekstblok_1.tekst_3 }}</p>
			</div>

			<div class="story-tekst" v-if="content">
				<div class="story-bodytekst">
					<h3>{{ content.tekst_10.tussenkop }}</h3>
					<p>{{ content.tekst_10.tekst_1 }}</p>
					<p>{{ content.tekst_10.tekst_2 }}</p>
					<p>{{ content.tekst_10.tekst_3 }}</p>
				</div>
			</div>

			<kinesis-container :event='"scroll"' :duration="1" class="story-telefoon-wrapper">
				<div class="story-telefoon-bg"></div>
				<kinesis-element 
					:strength="-500" 
					class="story-telefoon mobiel">
						<video playsinline loop muted autoplay class="story-scherm">
							<source :src='require("@/assets/video/mukbang.mp4")' type="video/mp4" />
							Uw browser ondersteunt het element <code>video</code> niet.
						</video>
						<p class="video-credit">Bron: Youtube</p>
				</kinesis-element>
			</kinesis-container>
					
			<div class="step" id="step_4"></div>

			<div class="story-tekst" v-if="content">
				<div class="story-bodytekst">
					<h3>{{ content.tekst_11.tussenkop }}</h3>
					<p>{{ content.tekst_11.tekst_1 }}</p>
					<p>{{ content.tekst_11.tekst_2 }}</p>
				</div>
			</div>

			<div class="story-tekst" v-if="content">
				<div class="story-bodytekst">
					<div class="call_to_action">
						<p v-html="content.call_to_action.tekst"></p>
					</div>
				</div>
			</div>

			<div class="story-tekstblok colofon" v-if="content">
				<h1>Colofon</h1>
				<p><b>Tekst en onderzoek</b> Odette Joosten en Karen Geurtsen <br/>
				<b>Data</b> Thomas de Beus<br/>
				<b>Design</b> Wendy van der Waal <br/>
				<b>Code</b> Els Engel <br/>
				<b>Eindredactie</b> René Sommer</p>
			</div>

			<!-- TELEFooNTJES -->
			<div class="story-telefoon slideIn" id="telefoon_0">
				<video playsinline loop muted autoplay class="story-scherm">
					<source :src='require("@/assets/video/0_intro_video.mp4")' type="video/mp4" />
					Uw browser ondersteunt het element <code>video</code> niet.
				</video>
				<p class="video-credit">Bron: TikTok/Youtube</p>
			</div>

			<div class="story-telefoon" id="telefoon_1">
				<TiktokSwiper/>
				<p class="video-credit-tiktok">Bron: TikTok</p>
			</div>

			<div id="telefoon_2">
			</div>

			<div class="story-telefoon" id="telefoon_3">
				<div class="citaat">
					<h3>{{ content.citaat.tekst }}</h3>
				</div>
			</div>

			<div class="story-telefoon" id="telefoon_4">
				<video playsinline loop muted autoplay class="story-scherm glen">
					<source :src='require("@/assets/video/mukbang.mp4")' type="video/mp4" />
					Uw browser ondersteunt het element <code>video</code> niet.
				</video>
				<p class="video-credit">Bron: Youtube</p>
			</div>
		</div>
	</div>
</template>

<script>
	import { defineAsyncComponent } from 'vue';
	import { KinesisContainer, KinesisElement} from 'vue-kinesis';
	// import TiktokSwiper from '../components/tiktokswiper';
	// import YoutubeSwiper from '../components/youtubeswiper';
	import Overgewicht from '../components/overgewicht.js';
	import { grafiekStates } from '../components/grafiekstates.js';

	const TiktokSwiper = defineAsyncComponent(() => import('../components/tiktokswiper'));
	const YoutubeSwiper = defineAsyncComponent(() => import('../components/youtubeswiper'));

	export default {
		name: 'Story',
		props: ['content', 'overgewichtData'],
		components: {
			TiktokSwiper,
			YoutubeSwiper
		},
		data: function() {
			return {
				overgewichtGrafiek: null,
				grafiekStates: grafiekStates(),
				currentState: 0,
				quizDone: false,
				quizVragen: [
					{
						antwoord: "5",
						correct: "fout",
						icon: require("@/assets/images/fout.png"),
						show_icon: false
					},
					{
						antwoord: "6",
						correct: "goed",
						icon: require("@/assets/images/grafiek_1.png"),
						show_icon: false
					},
					{
						antwoord: "7",
						correct: "fout",
						icon: require("@/assets/images/fout.png"),
						show_icon: false
					}
				]
			}
		},
		computed: {
		},
		mounted() {
			this.overgewichtGrafiek = new Overgewicht(this.overgewichtData, this.grafiekStates, this.$refs.overgewicht_grafiek, this.currentState);
			this.overgewichtGrafiek.maakGrafiek();
			
			//resize
			var rePosition;
			window.addEventListener("resize", () => {
				clearTimeout(rePosition);
				rePosition = setTimeout(() => {
					this.overgewichtGrafiek.resize();
				}, 500);
			});

			window.addEventListener('scroll', () => {
				this.checkStepVisibility();
			});

			window.setTimeout(() => { //fix zet kinesis elementen goed
				window.scrollTo(0, 1);
			}, 1000);
		},
		methods: {
			getButtonIcon(icon) {
				return require(`../assets/images/grafiek_${icon}.png`);
			},
			grafiekButtonClick() {
				this.currentState = this.grafiekStates[this.currentState].button_to;
				this.overgewichtGrafiek.changeState(this.currentState);
			},
			grafiekExplainClick() {
				this.currentState = this.grafiekStates[this.currentState].explain_to;
				this.overgewichtGrafiek.changeState(this.currentState);
			},
			checkStepVisibility() {
				const steps = document.querySelectorAll(".step");
				steps.forEach((step, i) => {
					if (this.isElementInViewport(step)) {
						steps.forEach((stepper, a) => {
							if (document.querySelector("#telefoon_" + a).classList.contains("slideIn")) {
								document.querySelector("#telefoon_" + a).classList.remove("slideIn")
								document.querySelector("#telefoon_" + a).classList.add("slideOut");
							}
						});
						document.querySelector("#telefoon_" + i).classList.add("slideIn");
					}
				});
			},
			isElementInViewport (el) {
				var rect = el.getBoundingClientRect();

				return (
					rect.top >= 0 &&
					rect.left >= 0 &&
					rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
					rect.right <= (window.innerWidth || document.documentElement.clientWidth)
				);
			},
			gotoLink(url) {
				window.open(url);
			},
			quizClick(index) {
				console.log("quizclick");
				this.quizDone = true;
				this.quizVragen[index].show_icon = true;
				this.quizVragen[1].show_icon = true;
			},
			getBtnClr(correct) {
				return this.quizDone ? correct : "";
			}
		}
	}
</script>